import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { SessionBookingComponent } from './modules/client/session-booking/session-booking.component';
import { ErrorPageComponent } from './modules/client/error-page/error-page.component';
import { BookingCancelComponent } from './modules/client/booking-cancel/booking-cancel.component';
import { BookingApproveComponent } from './modules/client/booking-approve/booking-approve.component';
import { BookingRescheduleComponent } from './modules/client/booking-reschedule/booking-reschedule.component';

export const appRoutes: Route[] = [

    {
        path: '',
        redirectTo:'bookings',
        pathMatch: 'full'
    },

    // Admin routes
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        children: [
            {path:'', redirectTo: 'error', pathMatch: 'full'},
            {path: 'bookings/:id', component:SessionBookingComponent},
            {path: 'cancellation/:id', component:BookingCancelComponent},
            {path: 'confirmation/:id', component:BookingApproveComponent},
            {path: 'rescheduling/:id', component:BookingRescheduleComponent},
            { path: 'error', component: ErrorPageComponent },
        ]
    },

    { path: '**', redirectTo: 'error' } // Fallback for unknown routes
];
